import CampaignPerformance from './campaign-performance';

export default CampaignPerformance;
